import React, {Component} from "react"
import {Container, Form, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, parseMultilineString} from "../utils/localization";
import Steps from "./steps/steps";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, getStepProps, handleSaveUserProgress, isAnsel, isAssociationContract, languages} from "../utils/common";
import {setFetchPlanRecommendation, setLeftoverMoney} from "../actions/userActions";
import Footer from "./footer";
import {CustomGrid} from "./custom-common";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        disposableIncomeOptions: initialData.disposableIncomeOptions,
        disposableIncomeSelect: user.leftoverMoney,
        name: user.name,
        lang: user.lang,
        user, initialData, benAdmin,
        contractType: initialData.contractType,
        ...ownProps
    }
};

class DisposableIncome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            needsUserProgressUpdate: false,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 1, uiFlow, distributionChannel)});
    }

    handleDisposableIncomeChange = (selectedKey) => {
        this.setState({needsUserProgressUpdate: true});
        this.props.dispatch(setLeftoverMoney(selectedKey));
        this.props.dispatch(setFetchPlanRecommendation(true));
    };

    render() {
        const {stepProps, needsUserProgressUpdate} = this.state;
        const {disposableIncomeOptions, disposableIncomeSelect, user, initialData, contractType} = this.props;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.healthPlanDetails;
        const stringsIn = strings.income;
        const isAssociation = isAssociationContract(contractType);

        const leftoverMoneyOpts = disposableIncomeOptions.map((o) => {
            return {key: o.id, value: o.id, text: o.value};
        });

        return <React.Fragment>
            <Container className={'contentContainer'}>
                <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                    <CustomGrid.Column width={8}>
                        <CustomGrid stackable columns={1}>
                            <CustomGrid.Row>
                                <CustomGrid.Column>
                                    <Header as="h2">{strings.budget}</Header>
                                    <p>{parseMultilineString(strings.subTitleFinancial)}</p>
                                </CustomGrid.Column>
                            </CustomGrid.Row>
                            <CustomGrid.Row>
                                <CustomGrid.Column>
                                    <p>
                                        {stringsIn.afterYouPay}<b>{stringsIn.necesities}</b>
                                        {parseMultilineString(stringsIn.houseingCar)}{' '}<b>{stringsIn.eachMonth}</b>{stringsIn.forDiscretionary}
                                    </p>

                                    <Form>
                                        <Form.Field>
                                            <Form.Group grouped>
                                            {leftoverMoneyOpts.map((lm) => {
                                                let text = lm.text;
                                                const localizationEng = getLocalization(languages.ENGLISH);
                                                const engStrings = localizationEng.healthPlanDetails.income;
                                                if(text === engStrings.opt1){
                                                    text = stringsIn.opt1;
                                                } else if(text === engStrings.opt2){
                                                    text = stringsIn.opt2;
                                                } else if(text === engStrings.opt3){
                                                    text = stringsIn.opt3;
                                                } else if(text === engStrings.opt4){
                                                    text = stringsIn.opt4;
                                                }
                                                return <React.Fragment key={lm.key}>
                                                    <Form.Radio label={text} className={'radioNormalFontSize'}
                                                                value={lm.value}
                                                                checked={disposableIncomeSelect === lm.value}
                                                                onChange={() => this.handleDisposableIncomeChange(lm.key)}
                                                    />
                                                </React.Fragment>
                                            })}
                                            </Form.Group>
                                        </Form.Field>
                                    </Form>
                                    <p style={{paddingTop: '2em'}}><b>{isAssociation ? stringsIn.disclaimerAssociation : stringsIn.disclaimer}</b></p>
                                </CustomGrid.Column>
                            </CustomGrid.Row>
                        </CustomGrid>
                    </CustomGrid.Column>
                </CustomGrid>
            </Container>
            <Footer
                showTopFooter={true} showCenterData={true}
                buttonText={localization.next}
                onClickCallback={() => {
                    if(needsUserProgressUpdate){
                        handleSaveUserProgress(initialData.token, user).then();
                    }
                    this.props.history.push(this.props.nextRoute)}
                }
                disabled={!disposableIncomeSelect}
            />
        </React.Fragment>;
    }
}

export default withRouter(connect(mapStateToProps)(DisposableIncome));
